import { createAsyncThunk } from "@reduxjs/toolkit";
import { addNotification, setError, setLoading } from "./reducer";
import { AddNotificationPayload } from "./types";

// Thunk para adicionar notificação com ícone baseado no tipo
export const addNotificationWithIcon = createAsyncThunk(
  "notifications/addWithIcon",
  async (payload: AddNotificationPayload, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      dispatch(setError(null));

      // Define ícone baseado no tipo se não foi fornecido
      let iconName = payload.iconName;
      if (!iconName) {
        switch (payload.type) {
          case "success":
            iconName = "CheckCircle";
            break;
          case "error":
            iconName = "AlertCircle";
            break;
          case "warning":
            iconName = "AlertTriangle";
            break;
          case "info":
          default:
            iconName = "Info";
            break;
        }
      }

      dispatch(
        addNotification({
          ...payload,
          iconName,
        })
      );

      return payload;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : "Erro desconhecido";
      dispatch(setError(errorMessage));
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);

// Thunk para notificação de sucesso (ação comum)
export const addSuccessNotification = createAsyncThunk(
  "notifications/addSuccess",
  async (message: string, { dispatch }) => {
    dispatch(
      addNotificationWithIcon({
        title: "Sucesso",
        message,
        type: "success",
      })
    );
  }
);

// Thunk para notificação de erro (ação comum)
export const addErrorNotification = createAsyncThunk(
  "notifications/addError",
  async (message: string, { dispatch }) => {
    dispatch(
      addNotificationWithIcon({
        title: "Erro",
        message,
        type: "error",
      })
    );
  }
);

// Thunk para notificação de aviso (ação comum)
export const addWarningNotification = createAsyncThunk(
  "notifications/addWarning",
  async (message: string, { dispatch }) => {
    dispatch(
      addNotificationWithIcon({
        title: "Aviso",
        message,
        type: "warning",
      })
    );
  }
);

// Thunk para notificação de info (ação comum)
export const addInfoNotification = createAsyncThunk(
  "notifications/addInfo",
  async (message: string, { dispatch }) => {
    dispatch(
      addNotificationWithIcon({
        title: "Informação",
        message,
        type: "info",
      })
    );
  }
);

// Thunk para simular recebimento de notificação do servidor (exemplo)
export const simulateServerNotification = createAsyncThunk(
  "notifications/simulateServer",
  async (_, { dispatch }) => {
    // Simula delay de rede
    await new Promise((resolve) => setTimeout(resolve, 1000));

    const messages = [
      "Novo pedido recebido #12345",
      "Produto em baixo estoque",
      "Backup realizado com sucesso",
      "Novo usuário cadastrado",
      "Relatório mensal disponível",
    ];

    const randomMessage = messages[Math.floor(Math.random() * messages.length)];

    dispatch(
      addNotificationWithIcon({
        title: "Sistema",
        message: randomMessage,
        type: "info",
        iconName: "Bell",
      })
    );
  }
);
